import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'modal-v2';
var ModalHeader = aggregatedClasses('div')(blockName, 'modal-header', function (_ref) {
  var _ref2;

  var type = _ref.type,
      showClose = _ref.showClose;
  return _ref2 = {}, _defineProperty(_ref2, type, type), _defineProperty(_ref2, 'with-close', showClose), _ref2;
});
var ModalHeaderTopRight = aggregatedClasses('div')(blockName, 'modal-header-close', function (_ref3) {
  var type = _ref3.type;
  return _defineProperty({}, type, type);
});
var ModalFeedback = aggregatedClasses('div')(blockName, 'modal-feedback', function (_ref5) {
  var type = _ref5.type;
  return _defineProperty({}, type, type);
});
var ModalTitle = aggregatedClasses('div')(blockName, 'modal-title', function (_ref7) {
  var type = _ref7.type;
  return _defineProperty({}, type, type);
});
var ModalContent = aggregatedClasses('div')(blockName, 'modal-content', function (_ref9) {
  var _ref10;

  var type = _ref9.type,
      removePadding = _ref9.removePadding;
  return _ref10 = {}, _defineProperty(_ref10, type, type), _defineProperty(_ref10, 'remove-padding', removePadding), _ref10;
});
var ModalWrapper = aggregatedClasses('div')(blockName, 'modal-wrapper', function (_ref11) {
  var _ref12;

  var type = _ref11.type,
      removePadding = _ref11.removePadding;
  return _ref12 = {}, _defineProperty(_ref12, type, type), _defineProperty(_ref12, 'remove-padding', removePadding), _ref12;
});
var ModalFooter = aggregatedClasses('div')(blockName, 'modal-footer', function (_ref13) {
  var _ref14;

  var type = _ref13.type,
      additionalFooterCssClass = _ref13.additionalFooterCssClass;
  return _ref14 = {}, _defineProperty(_ref14, type, type), _defineProperty(_ref14, additionalFooterCssClass, additionalFooterCssClass), _ref14;
});
var ModalFooterActions = aggregatedClasses('div')(blockName, 'modal-footer-actions', function (_ref15) {
  var type = _ref15.type;
  return _defineProperty({}, type, type);
});

export { ModalContent, ModalFeedback, ModalFooter, ModalFooterActions, ModalHeader, ModalHeaderTopRight, ModalTitle, ModalWrapper };
//# sourceMappingURL=blocks.js.map
